import React, { useState } from "react";

import { CloseOutlined } from "@ant-design/icons";
import PlusIcon from "@src/assets/icons/plus.svg";
import { StandardRoleList } from "@src/features/resource_plan/components/standard_role_list/index";
import { SearchInput } from "@src/features/table_filtering/components/search_input";
import { Button, Drawer, Form, Tooltip } from "antd";
import { debounce } from "lodash";
import "./role_request_creation_drawer.less";

interface RoleRequestCreationDrawerProps {
  projectId: string;
  isDisabled: boolean;
  isProjectEnded?: boolean;
}

const RoleRequestCreationDrawer: React.FC<RoleRequestCreationDrawerProps> = ({
  projectId,
  isDisabled,
  isProjectEnded = false,
}) => {
  const [form] = Form.useForm();
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState<string>("");

  /**
   *  Debounce the search input to avoid multiple filter calls
   */
  const onSearch = debounce((value: string) => {
    setSearchTerm(value);
  }, 300);

  /**
   *  Close the drawer and reset the search term
   */
  function onClose() {
    setIsDrawerOpen(false);
    setSearchTerm("");
    form.resetFields();
  }

  return (
    <>
      <Tooltip
        title={
          isProjectEnded &&
          "Project timeline ended. Please update the project date to add new requests."
        }
      >
        <Button
          icon={<PlusIcon />}
          type="primary"
          size="large"
          disabled={isDisabled}
          onClick={() => setIsDrawerOpen(true)}
          data-testid="add-role-sidebar"
        >
          Add Role
        </Button>
      </Tooltip>

      <Drawer
        className="role-request-creation-drawer"
        title="Add Role, Specification & Utilization"
        placement="right"
        width={344}
        closable={false}
        open={isDrawerOpen}
        onClose={onClose}
        extra={
          <Button icon={<CloseOutlined />} type="text" onClick={onClose} />
        }
      >
        <Form form={form}>
          <Form.Item name="search">
            <SearchInput
              onChange={(value: string) => onSearch(value)}
              disabled={isDisabled}
            />
          </Form.Item>
        </Form>
        <StandardRoleList
          searchTerm={searchTerm}
          projectId={projectId}
          onClose={onClose}
        />
      </Drawer>
    </>
  );
};

export default RoleRequestCreationDrawer;
